import React, { Component } from 'react';
import { getEspecialidade } from '../../Libs/especialidade'
import Select from 'react-select';
import SelectIcon from '../../gb-components/SelectIcon';
import Icon from '../../assets/svg/ic-medicine-heart-beat.svg';

// import { Container } from './styles';

export default class DropDownEspecialidade extends Component {

    state = {
        especialidades: null,
        especialidadeMultis: []
    }
    componentDidMount() {
        getEspecialidade().then(especialidades => {
            var auxEspecialidades = [];

            especialidades.forEach(e => {
                auxEspecialidades.push({
                    value: e,
                    label: e.especialidade.Nome
                });
            });

            this.setState({ especialidades, especialidadeMultis: auxEspecialidades })
        })
            .catch(error => {
            })
    }


    render() {
        return (
            this.props.mult ?
                <div className="form-group row pr-2 pl-2">
                    <label className="col-sm-12 control-label pl-0">Especialidades</label>
                    <div className="col-sm-12 gb-default-input2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div className="pt-1">
                            <img src={Icon} height={15} />
                        </div>
                        <div style={{width:'100%'}}>
                            <Select

                                isLoading={this.state.especialidadeMultis.length === 0}
                                isMulti
                                onChange={this.props.onChange}
                                name="Especialidades"
                                options={this.state.especialidadeMultis}
                                className="basic-multi-select gb-default-input2"
                                classNamePrefix="select"
                            />
                        </div>
                    </div>
                </div>
                :
                <SelectIcon
                    placeholder="Especialidade"
                    data={this.state.especialidades ?
                        this.state.especialidades.map((item, index) => {
                            return { id: item.especialidade.Nome, descricao: item.especialidade.Nome }
                        }) : []}
                    value={this.props.value}
                    icon={Icon}
                    change={event =>
                        this.props.change(event)
                    }
                    theme={this.props.theme}
                    label={this.props.label}
                    opcional={this.props.opcional}
                />
        );
    }
}